import { api, LightningElement, wire } from "lwc";
import { MultiLabelAdapter, LabelTranslations } from "tbme/localization";

export default class extends LightningElement {
  @api isSelf: boolean = false;
  @api label: string | null = null;
  @api value: string | null = null;
  @api href: string | null = null;
  @api linkAriaLabel: string | null = null;

  private labels: LabelTranslations = undefined!;

  get isVisible() {
    return this.isSelf || this.value;
  }

  get showAddButton() {
    return !this.value && this.isSelf;
  }

  get showValueAsLink() {
    return !!(this.value && this.href);
  }

  get valueLinkAriaLabel() {
    return this.linkAriaLabel || this.label;
  }

  addDetail() {
    this.dispatchEvent(new CustomEvent("add"));
  }

  handleLinkClick(evt: Event) {
    evt.preventDefault();
    if (this.href) {
      this.dispatchEvent(
        new CustomEvent("linkclick", {
          detail: { href: this.href },
          bubbles: true,
        })
      );
    }
  }

  @wire(MultiLabelAdapter, { labels: ["userDetails.add"] })
  private handleLabels(labels: { userDetails: LabelTranslations }) {
    this.labels = { ...labels.userDetails };
  }
}
